// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-datepicker {
  width: 230px;
}
.dashboard-datepicker .react-date-picker__wrapper {
  border: 1px solid #dadcdf;
  border-radius: 5px;
}

.dashboard-datepicker .react-date-picker__wrapper input {
  width: initial;
  border: none;
}

.dashboard-datepicker .react-date-picker__inputGroup {
  display: flex;
  align-items: center;
}

.dashboard-datepicker .react-date-picker__inputGroup input {
  width: 31px !important;
}
.dashboard-datepicker .react-calendar__tile--active,
.dashboard-datepicker .react-calendar__tile--now.react-calendar__tile--active {
  background: var(--main-font-color) !important;
}

.dashboard-datepicker .react-calendar__tile--active abbr {
  color: #ffffff !important;
}

.dashboard-datepicker .react-calendar__tile:disabled {
  background-color: #ffffff !important;
}

.dashboard-datepicker .react-calendar__tile:disabled abbr {
  color: #dadcdf;
}
.dashboard-datepicker .react-date-picker__calendar {
  width: 230px;
}
.dashboard-datepicker .react-calendar__month-view__weekdays__weekday abbr {
  text-decoration: none;
  font-size: 13px;
}

.dashboard-datepicker .react-calendar__month-view__days__day {
  border-radius: 25px;
}

.dashboard-datepicker .react-calendar__tile--now,
.dashboard-datepicker .react-calendar__tile--now:enabled:hover,
.dashboard-datepicker .react-calendar__tile--now:enabled:focus {
  background-color: #f5f5f5 !important;
}

.dashboard-datepicker
  .react-date-picker__calendar.react-date-picker__calendar--open {
  box-shadow: 0 1px 5px 0 rgba(197, 197, 197, 0.5);
}

.dashboard-datepicker .react-calendar {
  border: none !important;
}
.dashboard-datepicker .react-date-picker__inputGroup__input:invalid {
  background-color: inherit;
  color: #d24667;
  caret-color: #54585d;
}

.dashboard-datepicker .react-calendar__navigation button {
  min-width: auto;
}
button.react-date-picker__clear-button.react-date-picker__button:disabled {
  background: #f0f0f0;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-core/src/components/DatePicker/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;AACA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".dashboard-datepicker {\n  width: 230px;\n}\n.dashboard-datepicker .react-date-picker__wrapper {\n  border: 1px solid #dadcdf;\n  border-radius: 5px;\n}\n\n.dashboard-datepicker .react-date-picker__wrapper input {\n  width: initial;\n  border: none;\n}\n\n.dashboard-datepicker .react-date-picker__inputGroup {\n  display: flex;\n  align-items: center;\n}\n\n.dashboard-datepicker .react-date-picker__inputGroup input {\n  width: 31px !important;\n}\n.dashboard-datepicker .react-calendar__tile--active,\n.dashboard-datepicker .react-calendar__tile--now.react-calendar__tile--active {\n  background: var(--main-font-color) !important;\n}\n\n.dashboard-datepicker .react-calendar__tile--active abbr {\n  color: #ffffff !important;\n}\n\n.dashboard-datepicker .react-calendar__tile:disabled {\n  background-color: #ffffff !important;\n}\n\n.dashboard-datepicker .react-calendar__tile:disabled abbr {\n  color: #dadcdf;\n}\n.dashboard-datepicker .react-date-picker__calendar {\n  width: 230px;\n}\n.dashboard-datepicker .react-calendar__month-view__weekdays__weekday abbr {\n  text-decoration: none;\n  font-size: 13px;\n}\n\n.dashboard-datepicker .react-calendar__month-view__days__day {\n  border-radius: 25px;\n}\n\n.dashboard-datepicker .react-calendar__tile--now,\n.dashboard-datepicker .react-calendar__tile--now:enabled:hover,\n.dashboard-datepicker .react-calendar__tile--now:enabled:focus {\n  background-color: #f5f5f5 !important;\n}\n\n.dashboard-datepicker\n  .react-date-picker__calendar.react-date-picker__calendar--open {\n  box-shadow: 0 1px 5px 0 rgba(197, 197, 197, 0.5);\n}\n\n.dashboard-datepicker .react-calendar {\n  border: none !important;\n}\n.dashboard-datepicker .react-date-picker__inputGroup__input:invalid {\n  background-color: inherit;\n  color: #d24667;\n  caret-color: #54585d;\n}\n\n.dashboard-datepicker .react-calendar__navigation button {\n  min-width: auto;\n}\nbutton.react-date-picker__clear-button.react-date-picker__button:disabled {\n  background: #f0f0f0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
